<template>
    <div>
        <div class="relative z-0 flex flex-col w-full home-big px-2">
            <img data-object-fit="contain" style="object-fit: contain; max-width: 90%" src="@/assets/img/home/samsung.png" class="relative z-10 m-auto home-big-image w-auto mx-auto mt-10"/>
            
            <div class="absolute inset-0 z-20 px-3 flex flex-col items-center justify-center text-center">
                <img src="@/assets/img/logo-shadow.png" class="h-16 md:h-32 -mt-32 w-auto md:-mr-10"/>
                <span class="mt-3 text-4xl lg:text-5xl font-thin text-white md:tracking-big" style="text-shadow: 3px 3px 4px black;">La coque qui assure !</span>
            </div>

            <div class="absolute z-0 inset-0 flex overflow-hidden">
                <img src="@/assets/img/home/plus-black.svg" class="h-full w-auto mx-auto mt-32" style="opacity: 0.06; transform: scale(1.2)" />
            </div>

            <router-link to="/activation" class="relative z-20 px-5 py-3 md:px-16 md:py-6 md:mt-10 mx-auto md:text-lg font-bold text-white uppercase border border-white rounded-full shadow-xl transition duration-300 hover:text-red-800 hover:bg-white transform hover:scale-105 text-center">Activer mon assurance</router-link>
            <router-link to="/login" class="relative px-2 z-20 mx-auto mt-4 mb-5 text-sm text-center text-white">Assurance déjà activée ? Cliquez ici pour accéder à votre compte</router-link>
        </div>

        <div class="flex flex-col items-center relative z-0" style="background: #f2f2f2">
            <div class="p-5 flex flex-col text-center mx-auto w-full my-10 relative z-10" style="max-width: 800px;">
                <span class="text-black text-2xl md:text-4xl uppercase leading-tight font-bold">WeCare révolutionne l'assurance des smartphones en France</span>
                <span class="text-wecare-red text-2xl uppercase font-bold mt-2">Ceci est une révolution !</span>
            </div>

            <c-animation class="relative z-0" />
            
            <div class="flex flex-col flex-wrap justify-center sm:flex-row w-full pt-5 sm:p-5 relative z-10 py-5" style="max-width: 1300px;">
                <div class="flex w-full md:w-1/2 lg:w-1/3 p-3">
                    <div class="w-full flex flex-col items-center text-center border border-gray-300 bg-white px-4 py-8 rounded">
                        <img src="@/assets/img/home/argument-1.svg" class="h-24 my-6" />

                        <span class="text-lg xl:text-2xl uppercase text-wecare-red font-bold">Une protection de qualité</span>
                        <div class="my-4 w-full border-black border-b"></div>

                        <span class="font-bold text-base xl:text-lg"><span class="text-wecare-red">✓</span> Qualité supérieure de la coque</span>
                        <span class="text-base xl:text-lg text-gray-500">Haute sensibilité tactile</span>

                        <span class="font-bold text-base xl:text-lg mt-1"><span class="text-wecare-red">✓</span> Qualité supérieure du protège écran</span>
                    </div>
                </div>

                <div class="flex w-full md:w-1/2 lg:w-1/3 px-3 py-1">
                    <div class="w-full flex flex-col items-center text-center border border-gray-300 bg-white px-4 py-8 rounded">
                        <img src="@/assets/img/home/argument-2.svg" class="h-24 my-6" />

                        <span class="text-lg xl:text-2xl uppercase text-wecare-red font-bold">Une assurance d'un an</span>
                        <div class="my-4 w-full border-black border-b"></div>

                        <span class="font-bold text-base xl:text-lg"><span class="text-wecare-red">✓</span> Votre smartphone est assuré contre la casse pendant 12 mois !</span>
                        <span class="text-base xl:text-lg text-gray-500">(Ecran & face arrière)</span>

                        <span class="font-bold text-base xl:text-lg mt-1"><span class="text-wecare-red">✓</span> Prise en charge immédiate !</span>

                        <span class="font-bold text-base xl:text-lg mt-1"><span class="text-wecare-red">✓</span> Remplacement par le même smartphone neuf, s'il n’est pas réparable !</span>
                    </div>
                </div>

                <div class="flex w-full md:w-1/2 lg:w-1/3 p-3">
                    <div class="w-full flex flex-col items-center text-center border border-gray-300 bg-white px-4 py-8 rounded">
                        <img src="@/assets/img/home/argument-3.svg" class="h-24 my-6" />

                        <span class="text-lg xl:text-2xl uppercase text-wecare-red font-bold">Un prix accessible</span>
                        <div class="my-4 w-full border-black border-b"></div>

                        <span class="font-bold text-base xl:text-lg"><span class="text-wecare-red">✓</span> Paiement en une seule fois</span>
                        <span class="font-bold text-base xl:text-lg mt-1"><span class="text-wecare-red">✓</span> Pas de mensualité qu’on finit par oublier</span>
                        <span class="font-bold text-base xl:text-lg mt-1"><span class="text-wecare-red">✓</span> Simple, clair et transparent</span>
                    </div>
                </div>
            </div>

            <div class="py-8 px-3 bg-wecare-red w-full text-white flex flex-col">
                <span class="mx-auto text-center text-2xl sm:text-4xl font-bold uppercase">Tellement simple</span>
                <span class="text-black text-lg sm:text-2xl font-medium text-center mx-auto mt-1 uppercase">Comment ça marche ?</span>

                <div class="my-10 container mx-auto justify-center flex flex-wrap">
                    <div class="flex flex-col w-full md:w-1/2 lg:w-1/3 sm:px-10 items-center">
                        <img src="@/assets/img/steps/1-white.svg" class="h-12 w-auto" />
                        <div class="my-3 flex items-center">
                            <img src="@/assets/img/home/process-1.svg" class="h-12 w-auto mr-4" />
                            <span class="font-bold text-lg leading-tight">J'achète un pack de protection WeCare pour mon smartphone</span>
                        </div>

                        <img src="@/assets/img/home/process-img-1.png" class="w-auto mx-auto h-64 mt-4" style="object-fit:contain"/>
                    </div>

                    <div class="flex flex-col w-full md:w-1/2 lg:w-1/3 sm:px-10 items-center">
                        <img src="@/assets/img/steps/2-white.svg" class="h-12 w-auto" />
                        <div class="my-3 flex items-center">
                            <img src="@/assets/img/home/process-2.svg" class="h-12 w-auto mr-4" />
                            <span class="font-bold text-lg leading-tight">Je m’enregistre sur internet pour activer mon assurance</span>
                        </div>

                        <img src="@/assets/img/home/process-img-2.png" class="w-auto h-64 mx-auto mt-4" style="object-fit:contain"/>
                    </div>

                    <div class="flex flex-col w-full md:w-1/2 lg:w-1/3 sm:px-10 items-center">
                        <img src="@/assets/img/steps/3-white.svg" class="h-12 w-auto" />
                        <div class="my-3 flex items-center">
                            <img src="@/assets/img/home/process-3.svg" class="h-12 w-auto mr-4" />
                            <span class="font-bold text-lg leading-tight">Mon smartphone est assuré pendant 12 mois</span>
                        </div>

                        <img src="@/assets/img/home/process-img-3.png" class="w-auto h-64 mt-4" style="object-fit:contain"/>
                    </div>
                </div>
            </div>

            <div class="py-8 px-3 w-full text-white flex flex-col">
                <span class="mx-auto text-center text-2xl sm:text-4xl text-black font-bold uppercase">Nos bons plans</span>
                <span class="text-wecare-red font-medium text-lg sm:text-2xl  text-center mx-auto mt-1 uppercase">Vous assurez ! on vous l'assure !</span>

                <div class="my-10 container mx-auto justify-center flex flex-wrap">
                    <div class="w-full md:w-1/2 lg:w-1/3 p-1">
                        <div class="rounded relative overflow-hidden bg-white border border-gray-400 p-8 flex flex-col items-center text-center text-black leading-tight">
                            <div class="absolute top-0 left-0 bg-black text-white py-3 px-20 text-2xl" style="transform: rotate(-45deg) translate(-25%, -50%);">Nouveau</div>
                            <img src="@/assets/img/home/wecare-iphone-xr.png" class="w-auto h-64 mx-auto" style="object-fit:contain"/>
                            <span class="mt-8">Coque TPU Transparent</span>
                            <span>Protège écran 3D</span>
                            <span class="text-wecare-red">+ Assurance casse 12 mois</span>

                            <img src="@/assets/img/home/logo-apple.svg" class="w-auto h-10 mt-3 mx-auto" style="object-fit:contain"/>
                            <span class="mt-2 text-2xl"><span class="font-medium">Apple</span> iPhone XR</span>
                            <span class="text-5xl text-wecare-red font-light">49,90€</span>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 lg:w-1/3 p-1">
                        <div class="rounded bg-white border border-gray-400 p-8 flex flex-col items-center text-center text-black leading-tight">
                            <img src="@/assets/img/home/wecare-xiaomi-note-8t.png" class="w-auto h-64 mx-auto" style="object-fit:contain"/>
                            <span class="mt-8">Coque TPU Transparent</span>
                            <span>Protège écran 3D</span>
                            <span class="text-wecare-red">+ Assurance casse 12 mois</span>

                            <img src="@/assets/img/home/logo-mi.svg" class="w-auto h-10 mt-3 mx-auto" style="object-fit:contain"/>
                            <span class="mt-2 text-2xl">Redmi Note 8T</span>
                            <span class="text-5xl text-wecare-red font-light">24,90€</span>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 lg:w-1/3 p-1">
                        <div class="rounded bg-white border border-gray-400 p-8 flex flex-col items-center text-center text-black leading-tight">
                            <img src="@/assets/img/home/wecare-samsung-s10.png" class="w-auto h-64 mx-auto" style="object-fit:contain"/>
                            <span class="mt-8">Coque TPU Transparent</span>
                            <span>Protège écran 3D</span>
                            <span class="text-wecare-red">+ Assurance casse 12 mois</span>

                            <img src="@/assets/img/home/logo-samsung.svg" class="w-auto h-10 mt-3 mx-auto" style="object-fit:contain"/>
                            <span class="mt-2 text-2xl">Galaxy S10e</span>
                            <span class="text-5xl text-wecare-red font-light">39,90€</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CAnimation from './HomeAnimation'

export default {
    components: { CAnimation }
}
</script>